import { useMutation } from '@tanstack/react-query';

import { SystemComponent } from 'src/features/systems/utils/types';
import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/system/component/`;

type MutationFnType = typeof mutationFn;
interface DTO {
    parkingId: string;
    data: FormData;
}
const mutationFn = ({ parkingId, data }: DTO): Promise<SystemComponent> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useCreateSystemComponent };
export type { DTO as SystemComponentFormData };
